module.exports = __webpack_public_path__ + "static/media/logo_cafe.9dc3e5e3.png";